import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';

//import { CNAI } from 'Pages';

import { SNAI } from './SNAI';

export const baseURL = "/SNAI";



export const App: FC = (props) => {
  return (
  <Routes>
      <Route path={baseURL}>
        <Route index element={<SNAI />} />        
        <Route path="project/:id" element={<SNAI />} />        
      </Route>
    </Routes>

  );
};

export default App;